var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "react-toastify/dist/ReactToastify.min.css";
import "../css/toastNotification.css";
import { Alert, AlertActionCloseButton } from "@patternfly/react-core";
import { toast, ToastContainer } from "react-toastify";
export var ToastType;
(function (ToastType) {
    ToastType["DANGER"] = "danger";
    ToastType["INFO"] = "info";
    ToastType["SUCCESS"] = "success";
    ToastType["WARNING"] = "warning";
})(ToastType || (ToastType = {}));
var AlertComponent = function (_a) {
    var variant = _a.variant, message = _a.message, _b = _a.alertActions, alertActions = _b === void 0 ? {} : _b, closeToast = _a.closeToast, children = _a.children;
    return (_jsx(Alert, { variant: variant, title: message, actionClose: _jsx(AlertActionCloseButton, { onClose: closeToast }), children: children }));
};
var defaultCloseMs = 8000;
var defaultToastOptions = { autoClose: defaultCloseMs };
var ToastNotification = /** @class */ (function () {
    function ToastNotification() {
    }
    ToastNotification.addDangerMessage = function (message, alertBody, options) {
        if (options === void 0) { options = {}; }
        return toast(function (_a) {
            var closeToast = _a.closeToast;
            return (_jsx(AlertComponent, { variant: ToastType.DANGER, message: message, closeToast: closeToast, children: alertBody }));
        }, __assign({}, options));
    };
    // removed  options: ToastOptions = defaultToastOptions to fix auto-dismissing of success alerts.
    ToastNotification.addSuccessMessage = function (message, alertBody, options) {
        if (options === void 0) { options = defaultToastOptions; }
        return toast(function (_a) {
            var closeToast = _a.closeToast;
            return (_jsx(AlertComponent, { variant: ToastType.SUCCESS, message: message, closeToast: closeToast, children: alertBody }));
        }, __assign({}, options));
    };
    ToastNotification.addWarningMessage = function (message, options) {
        if (options === void 0) { options = {}; }
        return toast(function (_a) {
            var closeToast = _a.closeToast;
            return (_jsx(AlertComponent, { variant: ToastType.WARNING, message: message, closeToast: closeToast }));
        }, __assign({}, options));
    };
    ToastNotification.addInfoMessage = function (message, options) {
        if (options === void 0) { options = defaultToastOptions; }
        return toast(function (_a) {
            var closeToast = _a.closeToast;
            return (_jsx(AlertComponent, { variant: ToastType.INFO, message: message, closeToast: closeToast }));
        }, __assign({}, options));
    };
    ToastNotification.clearAll = function () {
        toast.dismiss();
    };
    ToastNotification.clearToast = function (toastId) {
        toast.dismiss(toastId);
    };
    return ToastNotification;
}());
export { ToastContainer, ToastNotification };
